exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sketch[data-v-447fffc6]{width:60px;height:60px}.configure[data-v-447fffc6]{cursor:move}.background[data-v-447fffc6]{width:40px;height:40px;x:10;y:10;opacity:0}.picture[data-v-447fffc6]{cx:30;cy:30;r:20;fill:#93a1a1;stroke:#333;stroke-width:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-447fffc6&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/stateStart.vue
// module id = 49
// module chunks = 0